<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-novel__novel}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.novelCode" placeholder="小说ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.novelName" placeholder="小说名字" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.dictCode" placeholder="请选择分类">
            <el-option
              v-for="item in pDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('novel:novel:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('novel:novel:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="novelCode" label="小说ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="novelName" label="小说名字" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dictName" label="分类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="novelImage" label="封面图" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.novelImage" width="100" height="40" alt=""/>
          </template>
        </el-table-column>
        <el-table-column prop="novelSeria" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.novelSeria == 0" type="success">连载</el-tag>
            <el-tag v-if="scope.row.novelSeria == 1" type="success">完结</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="novelHot" label="热度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="novelAuthor" label="更新详情" header-align="center" align="center"></el-table-column>
        <el-table-column prop="novelIntroduce" label="小说简介" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="InfoHandle(scope.row.novelCode)">查看章节</el-button>
            <el-button v-if="$hasPermission('novel:novel:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.novelCode)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('novel:novel:delete')" type="text" size="small" @click="deleteHandle(scope.row.novelCode)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-novel'
import AddOrUpdate from './novel-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/novel/novel/page',
        getDataListIsPage: true,
        exportURL: '/novel/novel/export',
        deleteURL: '/novel/novel',
        deleteIsBatch: true
      },
      type:'1',
      pDict:[],
      dataForm: {
        novelCode: '',
        novelName: '',
        dictCode: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created(){
    this.getpDict()
  },
  methods: {
    getpDict() {
      this.$http.get(`/sondict/sondict/getpDict/${this.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pDict = res.data
      }).catch(() => {})
    },
    InfoHandle(id){
      // this.$router.push({name: "moviesinfo-moviesinfo",params:{cartoonCode:id}});
     
      this.$router.push({path:'novelinfo-novelinfo',query:{novelCode:id}})
    },
  }
}
</script>
